import { FivetranServiceEnum, quickbooksSchema } from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

/** Setup form for the QuickBooks Fivetran connector (Connect Card OAuth). */
export const QuickbooksFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.quickbooks,
    schema: quickbooksSchema,
    defaultConfig: { schema: FivetranServiceEnum.enum.quickbooks },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="quickbooks"
      submitLabel="Authenticate"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />
    </ConnectionFormShell>
  );
};
